import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AgreementsModalInvokerService } from 'src/app/services/agreements-modal-invoker/agreements-modal-invoker.service';
import { CcAdminApiService } from 'src/app/services/ccAdmin/cc-admin-api.service';
import { onlyFalsy } from 'src/app/utils/rxjs-custom-operators/rxjs-custom-operators.utils';
import { AgreementsAcceptanceComponent } from '../agreements-acceptance/agreements-acceptance.component';

@Component({
	selector: 'app-agreements-modal-invoker',
	templateUrl: './agreements-modal-invoker.component.html',
	styleUrls: ['./agreements-modal-invoker.component.scss'],
	standalone: true,
	imports: [AgreementsAcceptanceComponent],
})
export class AgreementsModalInvokerComponent implements OnInit, OnDestroy {
	openAgreementsModal: () => void;
	hasAcceptedAllAgreements: boolean;

	private destroy: Subject<void> = new Subject();

	constructor(
		private ccAdminApiService: CcAdminApiService,
		private agreementsModalInvokerService: AgreementsModalInvokerService
	) {}

	ngOnInit(): void {
		this.ccAdminApiService.graphInitialized$.pipe(take(1)).subscribe(() => {
			/** Load the Orchestrate user info and thus get agreements (begin loading up data so loadingData$ gets initialized)
			 * Executing this function is very important for loading the workflows because we want hasAcceptedAllAgreements to finally have a bool value * */
			this.agreementsModalInvokerService.loadAgreements();

			/** If the user did not accept the agreements, prompt the agreements content modal only after the token is valid */
			forkJoin([
				this.agreementsModalInvokerService.loadingData$.pipe(onlyFalsy(), take(1)),
				this.agreementsModalInvokerService.hasAcceptedAllAgreements$.pipe(take(1)),
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
			]).subscribe(([_, hasAcceptedAllAgreements]) => {
				if (!hasAcceptedAllAgreements) {
					this.openAgreementsModal();
				}
			});

			this.agreementsModalInvokerService.hasAcceptedAllAgreements$
				.pipe(takeUntil(this.destroy))
				.subscribe(hasAcceptedAllAgreements => {
					this.hasAcceptedAllAgreements = hasAcceptedAllAgreements;
				});
		});
	}

	ngOnDestroy() {
		this.destroy.next();
		this.destroy.complete();
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
